module.exports = __webpack_public_path__ + "static/img/42645589_2l.fc48cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/42645589_2l.jpg
// module id = LMba
// module chunks = 6